// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".roundProfile{border-radius:.5rem .5rem 0 0;width:100%;-o-object-fit:cover;object-fit:cover;aspect-ratio:4/3}", ""]);
// Exports
module.exports = exports;
